import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/component.layout';
import SEO from '../components/component.seo';
import HeroBanner from '../components/hero-banner/component.banner';
import FAQBanner from '../components/contact/component.faq';
import CallUs from '../components/contact/component.callus';
import ContactForm from "../components/contact/component.contact-form";
import ComponentParser from '../components/component.parser';
import Content from '../components/component.content';
import CookieNotice from "../components/component.cookie-notice";

const Contact = ({ data }) => {
    const { title, content, blocks, featuredImage, seo } = data.wordpress.page;
    const bannerImage = featuredImage ? featuredImage.node.imageFile : false;

    return (
        <Layout>
            <SEO title={title} seo={seo} image={featuredImage} />
            <HeroBanner title={title} image={bannerImage} />

            <div className="u-bg--seashell xs-pt-40 xs-pb-40">
                <div className="container">
                    {content &&
                        <Content content={content} boxed />
                    }

                    {blocks &&
                        <ComponentParser blocks={blocks} />
                    }

                    <FAQBanner title="Have a question?" subtitle="We have answers" linkLabel="Check out FAQs" linkUrl="/faqs/" />
                    <CallUs title="Call us" subtitle="Please select the relevant country" />
                    <ContactForm />
                </div>
            </div>
            <CookieNotice />
        </Layout>
    );
};

export const query = graphql`
    query($id: ID!) {
        wordpress {
            page(id: $id) {
                title
                slug
                content
                featuredImage {
                    node {
                        altText
                        sourceUrl
                        imageFile {
                            childImageSharp {
                                fluid(maxWidth: 1140) {
                                    ...GatsbyImageSharpFluid_withWebp_tracedSVG
                                }
                            }
                        }
                    }
                }
                seo {
                    ...SeoPostFields
                }
                ...PageBlocks
            }
        }
    }
`;

export default Contact;
